import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackContextMenuClick } from './tracking';
import { ChatListContextMenu } from '../../components/ChatList/ChatListContextMenu';
import { useOfferByChatId, useOpponentByChatId } from '../../hooks';
import { useChatListContextMenuActions } from '../../hooks/useChatListContextMenuActions';
import { chatListSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';

type TChatListContextMenuContainerProps = {
  listRef: React.RefObject<HTMLDivElement>;
};

export const ChatListContextMenuContainer: React.VFC<TChatListContextMenuContainerProps> = ({ listRef }) => {
  const menuItems = useChatListContextMenuActions();
  const { isChangeListActive } = useSelector(chatListSelector);
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const getOfferByChatId = useOfferByChatId();
  const getOpponentByChatId = useOpponentByChatId();

  const onShowContextMenu = React.useCallback(
    (selectedChatId: string) => {
      const offer = getOfferByChatId(selectedChatId);
      const opponentId = getOpponentByChatId(selectedChatId);

      trackContextMenuClick(offer, opponentId);
    },
    [getOfferByChatId, getOpponentByChatId],
  );

  if (isMobile || isChangeListActive) {
    return null;
  }

  return <ChatListContextMenu listRef={listRef} menuItems={menuItems} onShowContextMenu={onShowContextMenu} />;
};
